// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "javascript/chunks/" + "4e69b7131e1ffd2d2ec6" + ".min.js";
};